var map = {
	"./type.svg": 1118,
	"./typearrow.svg": 1119,
	"./typebicycle.svg": 1120,
	"./typeboat.svg": 1121,
	"./typebus.svg": 1122,
	"./typecar.svg": 432,
	"./typecrane.svg": 1123,
	"./typecrane_bcp.svg": 1124,
	"./typegenerator.svg": 1125,
	"./typehelicopter.svg": 1126,
	"./typemotorcycle.svg": 1127,
	"./typeoffroad.svg": 1128,
	"./typeperson.svg": 1129,
	"./typepickup.svg": 1130,
	"./typeplane.svg": 1131,
	"./typeship.svg": 1132,
	"./typetractor.svg": 1133,
	"./typetruck.svg": 1134,
	"./typevan.svg": 1135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 701;